import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IFoCaAnTruongRequest } from '../../../models/request/thuc-don/IFoCaAnTruongRequest';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { IFoCaAnTruong } from '../../../models/response/thuc-don/IFoCaAnTruong';
import { eFoCaAnTruongActionTypeIds, IFoCaAnTruongActionTypes } from '../../action-types/thuc-don/IFoCaAnTruongActionTypes';
import { actions } from '../../actions/actionsWrapper';


export function* foCaAnTruongSaga(): any {
    yield takeLatest(eFoCaAnTruongActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eFoCaAnTruongActionTypeIds.LOAD_COSO_START, selectByCoSoWorker)
    yield takeLatest(eFoCaAnTruongActionTypeIds.LOAD_CAAN_START, selectByCaAnWorker)
    yield takeEvery(eFoCaAnTruongActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eFoCaAnTruongActionTypeIds.DELETE_START, deleteWorker)


}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.caAnTruong.select_all)
    if (res.is_success) {
        yield put(actions.thucDonWrapper.caAnTruong.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.thucDonWrapper.caAnTruong.LOAD_ERROR(res.message ?? "Error"))
    }
}
function* selectByCoSoWorker(action: IFoCaAnTruongActionTypes): any {
    const payload: number = action.payload as number;

    const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.caAnTruong.select_by_coso, payload)
    if (res.is_success) {
        yield put(actions.thucDonWrapper.caAnTruong.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.thucDonWrapper.caAnTruong.LOAD_ERROR(res.message ?? "Error"))
    }
}
function* selectByCaAnWorker(action: IFoCaAnTruongActionTypes): any {
    const payload: IFoCaAnTruongRequest = action.payload as IFoCaAnTruongRequest;

    const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.caAnTruong.select_by_caan, payload)
    if (res.is_success) {
        yield put(actions.thucDonWrapper.caAnTruong.LOAD_CAAN_SUCCESS(res.data))
    } else {
        yield put(actions.thucDonWrapper.caAnTruong.LOAD_CAAN_ERROR(res.message ?? "Error"))
    }
}
function* saveWorker(action: IFoCaAnTruongActionTypes): any {
    const payload: IFoCaAnTruong = action.payload as IFoCaAnTruong;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.thucDonWrapper.caAnTruong.update, payload)
    } else {
        res = yield call(apiWrapper.thucDonWrapper.caAnTruong.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.thucDonWrapper.caAnTruong.SAVE_SUCCESS(res.data))
    } else {
        yield put(actions.thucDonWrapper.caAnTruong.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IFoCaAnTruongActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.caAnTruong.delete, payload)
    if (res.is_success) {
        yield put(actions.thucDonWrapper.caAnTruong.DELETE_SUCCESS(undefined))
    } else {
        yield put(actions.thucDonWrapper.caAnTruong.DELETE_ERROR(res.message ?? "Error"))
    }
}